var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"col-md-12 mx-auto"},[_c('participant-edit',{attrs:{"id":_vm.id,"details":_vm.details}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }